module.exports = __webpack_public_path__ + "img/play.d3783636.png";